import React, { useState, useEffect } from 'react';
import { Text, Flex, Spinner, useColorModeValue } from '@chakra-ui/react';
import API from '../../api/api';

export default function VersionDisplay({ align = 'left' }) {
  const [backendVersion, setBackendVersion] = useState(null);
  const [loading, setLoading] = useState(true);
  const textColor = useColorModeValue('gray.500', 'gray.400');

  const frontendVersion = process.env.REACT_APP_VERSION || 'dev';

  useEffect(() => {
    const fetchBackendVersion = async () => {
      try {
        const response = await API.get('/health', {
          headers: { 'X-Skip-Auth': 'true' },
        });

        if (response.data && response.data.version) {
          setBackendVersion(response.data.version);
        }
      } catch (error) {
        console.error('Failed to fetch backend version:', error);
        setBackendVersion('unknown');
      } finally {
        setLoading(false);
      }
    };

    fetchBackendVersion();
  }, []);

  const formatVersion = (version) => {
    if (!version || version === 'dev' || version === 'unknown') {
      return version;
    }
    return version.substring(0, 6);
  };

  return (
    <Flex direction="row" gap={2} textAlign={align} align="center">
      <Text as="span" fontSize="xs" color={textColor}>
        FE: <strong>{formatVersion(frontendVersion)}</strong>
      </Text>
      <Text as="span" fontSize="xs" color={textColor}>
        BE:{' '}
        {loading ? (
          <Spinner size="xs" ml={1} />
        ) : (
          <strong>{formatVersion(backendVersion)}</strong>
        )}
      </Text>
    </Flex>
  );
}
